module.exports = __webpack_public_path__ + "img/ssad.f7b15a51.png";